export const symbols = {
  volume: 'm³',
}
